<template>
    <div class="product-tile" :class="{'product-tile--show': show, 'product-tile--overlay': overlay}" @click="toggle()">
        <div class="product-tile__image" :style="`background-image: url(${product.full_image_path})`">
        </div>

        <button data-test="overlay-trigger" type="button" class="product-tile__overlay-button" @click.stop="overlay = !overlay">
            <svg role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 448c-110.532 0-200-89.431-200-200 0-110.495 89.472-200 200-200 110.491 0 200 89.471 200 200 0 110.53-89.431 200-200 200zm0-338c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z" class=""></path></svg>
        </button>

        <div class="product-tile__category">
            {{ product.category }}
        </div>

        <div class="product-tile__title">
            {{ product.title }}
        </div>

        <div class="product-tile__description" v-if="overlay" v-html="product.description"> </div>

        <div class="product-tile__footer">
            <template v-if="!selected">
                <img src="/images/icons/cart-arrow-down.svg" />
            </template>
            <template v-if="selected">
                <img src="/images/icons/check-circle.svg" />
                <input type="hidden" name="products[]" :value="product.id" />
            </template>

            <div class="product-tile__price">
                {{ trans('products.price') }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        product: Object,
        preselect: Boolean,
        show: {
            type: Boolean,
            default: () => true,
        },
    },

    data() {
        return {
            overlay: false,
            selected: this.preselect,
        };
    },

    methods: {
        toggle() {
            this.selected = !this.selected;

            if (this.selected) {
                this.$emit('selected', this.product.id);
            } else {
                this.$emit('unselected', this.product.id);
            }
        },
    },
}
</script>
